import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnDestroy,
    Output,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {UntypedFormBuilder, FormControl} from "@angular/forms";
import {Router} from "@angular/router";
import {Api} from "../../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../../common/services/toast.service";
import {ConfirmComponent} from "../../../../../../../common/components/confirm/confirm.component";
import {SpinnerService} from "../../../../../../../common/services/spinner.service";
import {User} from "../../../../../../../common/interfaces/user.interface";
import {Api3Service} from "../../../../../../../common/services/api3.service";
import {Warehouse} from "../../../../../../../common/interfaces/warehouse.interface";
import {AdminPartnerCarrierService} from "../../../../services/partner-carrier.service";
import {Table} from "../../../../../../../common/interfaces/table.interface";
import {AppStateService} from "../../../../../../../common/services/app-state.service";
import {WizardStepFactory} from "../../../../../../../common/interfaces/wizard.interface";
import {
    PartnerProceduresWizardAddSerialComponent, PartnerProceduresWizardBoxRefChangeComponent,
    PartnerProceduresWizardLinkSerialToBoxComponent,
    PartnerProceduresWizardPalletRefChangeComponent, PartnerProceduresWizardRemoveSerialComponent,
    PartnerProceduresWizardSerialToQtyComponent, PartnerProceduresWizardTransferUpdatePalletComponent,
    PartnerProceduresWizardUnlinkSerialFromBoxComponent, PartnerProceduresWizardUpdateBatchComponent,
    PartnerProceduresWizardUpdateBoxHubComponent, PartnerProceduresWizardUpdateConfigurationForSerialComponent,
    PartnerProceduresWizardUpdateHubComponent,
    PartnerProceduresWizardUpdateItemComponent,
    PartnerProceduresWizardUpdateItemForSerialComponent,
    PartnerProceduresWizardUpdatePalletHubComponent, PartnerProceduresWizardUpdateQuantityComponent,
    PartnerProceduresWizardUpdateSerialComponent
} from "../../../../../partner/components/procedures/wizard";

@Component({
    selector: "section-partner-form-step6",
    templateUrl: "step6.component.html",
    styleUrls: [
        "step6.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class PartnerFormStep6Component implements OnDestroy {

    /**
     * Component destroy event emitter
     * @type {EventEmitter<boolean>}
     */
    private destroy$: EventEmitter<boolean> = new EventEmitter<boolean>();

    private partner: User.IPartner;

    @Output()
    public result: EventEmitter<any> = new EventEmitter();

    @Output()
    public authFail: EventEmitter<any> = new EventEmitter();

    @ViewChild(ConfirmComponent, {static: false})
    public confirmRef: ConfirmComponent;

    public mrbs: { slug: string, name: string }[] = [
        {
            name: "Add Serial item to stock",
            slug: "serial-add"
        },
        {
            name: "Remove Serial item from stock",
            slug: "serial-remove"
        },
        {
            name: "Change Serial for item in stock",
            slug: "serial-change"
        },
        {
            name: "Change Part Number for Serial item in stock",
            slug: "item-change-serial"
        },
        {
            name: "Convert Serial item to a quantity managed item",
            slug: "serial-to-qty"
        },
        {
            name: "Change Configuration for Serial item in stock",
            slug: "item-change-configuration"
        },
        {
            name: "Unlink Serial from box",
            slug: "unlink-serial-from-box"
        },
        {
            name: "Link serial to box",
            slug: "link-serial-to-box"
        },
        {
            name: "Change Part Number for Non Serial item in stock",
            slug: "item-change"
        },
        {
            name: "Change Qty in stock for Non Serial item",
            slug: "quantity-change"
        },
        {
            name: "Move Serial/ Non serial item between Sub inventories",
            slug: "hub-change"
        }
        , {
            name: "Update item Batch/Lot/Rev",
            slug: "item-batch"
        }
        , {
            name: "Move boxes between Sub inventories",
            slug: "box-hub-change"
        },
        {
            name: "Box Ref change",
            slug: "box-ref-change"
        },
        {
            name: "Pallet Ref change",
            slug: "pallet-ref-change"
        },
        {
            name: "Update pallet location",
            slug: "pallet-location",
        },
        {
            name: "Update pallet sub inventory",
            slug: "pallet-hub",
        },
    ];


    public allowed_mrbs: any[] = [];

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private api3Service: Api3Service,
        private spinnerService: SpinnerService,
        protected toastService: ToastService
    ) {
    }

    private async getPartnerMrbs(): Promise<any> {

        const {data}: Api.IResponse = await this.api3Service.get(`admin/partners/${this.partner.id}/mrbs`, {});

        if (data) {
            this.allowed_mrbs = data;
            this.changeDetectorRef.markForCheck();
        }
    }

    public async toggleMrb(mrb_slug: string, is_active: boolean): Promise<any> {

        const {code}: Api.IResponse = await this.api3Service.post(`admin/partners/${this.partner.id}/mrbs`, {
            mrb_slug,
            is_active
        });

        if (code === 200) {
            this.toastService.show("MRB status changed", "success");
            this.getPartnerMrbs();
        }
    }

    /**
     * Initialize step
     * @returns {Promise<any>}
     * @param partner
     */
    public async init(partner: User.IPartner): Promise<any> {
        this.partner = partner;
        this.getPartnerMrbs();
        this.result.next(true);
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
